import { isAxiosError } from 'axios';
import { capitalize } from '@/utils/capitalize';

export function prettifyTransformErrorMessage(error: Error | null | undefined) {
  if (!error) {
    return undefined;
  }

  if (isAxiosError(error)) {
    let errorMessage = capitalize(
      error.response?.data?.message as string | undefined,
    );

    // TODO: Check if this is correct casing for traceId.
    if (error.response?.data?.traceId) {
      errorMessage += `\n\nTrace ID: ${error.response?.data?.traceId}`;
    } else if (error.response?.data?.traceID) {
      errorMessage += `\n\nTrace ID: ${error.response?.data?.traceID}`;
    }

    return errorMessage ?? error.message;
  }

  return error?.message;
}
